// Enum
export enum EventType {
  ApplicationViewed = "Application Viewed",
  ShortList = "ShortList",
  JobClose = "Job Close",
  CandidatePlaced = "Candidate Placed",
  ReferralCandidatePlaced = "Referral Candidate Placed",
  InterviewScheduled = "Interview Scheduled",
  JobExpirationAlert = "Job Expiration Alert",
  ReferralUpdated = "Referral Updated",
  CandidateInvite = "Candidate Invite",
  ReferralInvite = "Referral Invite",
  ReferralInviteAction = "Referral Invite Action",
  CandidateInviteAction = "Candidate Invite Action",
  ReferralDetailAccessRequest = "Referral Detail Access Request",
  CandidateDetailAccessApproved = "Candidate Detail Access Approved",
  ReferralRatingNow = "Referral Rating Now",
  ReferralMatchedJobRated = "Referral Matched Job Rated",
  RecruiterApprovalRequest = "Recruiter Approval Request",
  RecruiterApprovalApproved = "Recruiter Approval Approved",
  InterviewReminder = "Interview Reminder",
  PartnerAgencyRequest = "Partner Agency Request",
}

// Type from Enum
export type EventTypeKey = keyof typeof EventType;
